// Mock data for Construction Cards Helpline website

export const companyInfo = {
  name: "Construction Cards Helpline Limited",
  address: "124 City Road, London EC1V 2NX",
  email: "info@constructioncardshelpline.co.uk",
  phone: "+44 7848 482492",
  whatsapp: "+447848482492",
  businessHours: "Monday - Friday: 8:00 AM - 6:00 PM\nSaturday: 9:00 AM - 2:00 PM\nSunday: Closed"
};

export const heroImages = {
  main: "https://images.unsplash.com/photo-1593436878396-e943a3cac98f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMHNhZmV0eSUyMHZlc3QlMjBjcmFuZXxlbnwwfHx8fDE3OTEwNTAzNTV8MA&ixlib=rb-4.1.0&q=85",
  alt1: "https://images.unsplash.com/photo-1640101086894-7d70c3e70179?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMHNhZmV0eSUyMHZlc3QlMjBjcmFuZXxlbnwwfHx8fDE3OTEwNTAzNTV8MA&ixlib=rb-4.1.0&q=85",
  alt2: "https://images.unsplash.com/photo-1694521787673-28cbd8830ea5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMHNhZmV0eSUyMHZlc3QlMjBjcmFuZXxlbnwwfHx8fDE3OTEwNTAzNTV8MA&ixlib=rb-4.1.0&q=85"
};

export const serviceImages = {
  excavator1: "https://images.unsplash.com/photo-1628645419184-26a1f2757340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxleGNhdmF0b3J8ZW58MHx8fHwxNzcxMzEzNjMxfDA&ixlib=rb-4.1.0&q=85",
  excavator2: "https://images.unsplash.com/photo-1649807533255-bbc9c9fb7d77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxleGNhdmF0b3J8ZW58MHx8fHwxNzcxMzEzNjMxfDA&ixlib=rb-4.1.0&q=85",
  excavator3: "https://images.unsplash.com/photo-1630288214173-a119cf823388?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxleGNhdmF0b3J8ZW58MHx8fHwxNzcxMzEzNjMxfDA&ixlib=rb-4.1.0&q=85",
  training: "https://images.unsplash.com/photo-1640101086894-7d70c3e70179?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMHNhZmV0eSUyMHZlc3QlMjBjcmFuZXxlbnwwfHx8fDE3OTEwNTAzNTV8MA&ixlib=rb-4.1.0&q=85"
};

export const backgroundImages = {
  team: "https://images.unsplash.com/photo-1593436878396-e943a3cac98f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMHNhZmV0eSUyMHZlc3QlMjBjcmFuZXxlbnwwfHx8fDE3OTEwNTAzNTV8MA&ixlib=rb-4.1.0&q=85",
  handshake: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHx0ZWFtd29ya3xlbnwwfHx8fDE3NzEzMTM2Njh8MA&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: 1,
    title: "CSCS Card & Test Booking",
    icon: "CreditCard",
    description: "Fast CSCS test booking and card processing for all levels",
    shortDesc: "Get your CSCS card quickly with our expert support",
    benefits: ["Same-day test booking available", "All card types supported", "Expert guidance", "High pass rate"],
    link: "/cscs-services",
    featured: false
  },
  {
    id: 5,
    title: "Green Labour Card (Level 1)",
    icon: "Award",
    description: "Fast-track entry level CSCS card for construction labourers",
    shortDesc: "Perfect for construction labourers - Apply today",
    benefits: ["1-day course", "Entry to all UK sites", "Fast processing", "Expert support"],
    link: "/green-labour-card",
    featured: true
  },
  {
    id: 2,
    title: "NVQ Courses Level 2-7",
    icon: "GraduationCap",
    description: "Comprehensive NVQ qualifications for all construction trades",
    shortDesc: "Professional NVQ training for career advancement",
    benefits: ["Level 2 to Level 7 available", "All trades covered", "Fast track options", "Portfolio building support"],
    link: "/nvq-courses"
  },
  {
    id: 3,
    title: "CPCS Plant Operator Cards",
    icon: "Truck",
    description: "CPCS training and testing for plant machinery operators",
    shortDesc: "Become a certified plant operator with CPCS cards",
    benefits: ["360 Excavator", "Dumpers & Rollers", "Telehandlers", "Red & Blue cards"],
    link: "/cpcs-courses"
  },
  {
    id: 4,
    title: "SSSTS & SMSTS Courses",
    icon: "Users",
    description: "Site management training for supervisors and managers",
    shortDesc: "Essential site safety management qualifications",
    benefits: ["SSSTS for supervisors", "SMSTS for managers", "CITB approved", "UK recognized"],
    link: "/site-management"
  }
];

export const cscsCards = [
  {
    type: "Green Labourer Card",
    level: "Entry Level",
    requirement: "Level 1 Award + CSCS Test",
    duration: "1 day course",
    price: "From £150",
    features: ["Health & Safety Test", "Entry level qualification", "Fast processing", "Expert support"],
    popular: true
  },
  {
    type: "Blue Skilled Worker Card",
    level: "Level 2 NVQ",
    requirement: "NVQ Level 2 + CSCS Test",
    duration: "6-8 weeks",
    price: "£787",
    features: ["Skilled worker status", "Industry recognized", "Valid for 5 years", "All trades supported"]
  },
  {
    type: "Gold Card",
    level: "Level 3 & 4 NVQ",
    requirement: "NVQ Level 3/4 + CSCS Test",
    duration: "8-12 weeks",
    price: "£1,120",
    features: ["Advanced qualification", "Supervisory level", "Valid for 5 years", "Career progression"]
  },
  {
    type: "Black Card",
    level: "Level 6 & 7 NVQ",
    requirement: "NVQ Level 6/7 + CSCS Test",
    duration: "12-16 weeks",
    price: "£1,480",
    features: ["Management level", "Highest qualification", "Valid for 5 years", "Industry leadership"]
  }
];

export const cpcsCategories = [
  {
    name: "360 Excavator",
    code: "A59",
    type: "Tracked & Wheeled",
    duration: "5 days training + 1 day test",
    price: "From £1,200",
    image: serviceImages.excavator1,
    description: "Operate 360-degree excavators above and below 10 tonnes"
  },
  {
    name: "Forward Tipping Dumper",
    code: "A09",
    type: "All sizes",
    duration: "3 days training + 1 day test",
    price: "From £800",
    image: serviceImages.excavator2,
    description: "Operate forward tipping dumpers safely on construction sites"
  },
  {
    name: "Ride on Roller",
    code: "A31",
    type: "Compaction equipment",
    duration: "3 days training + 1 day test",
    price: "From £750",
    image: serviceImages.excavator3,
    description: "Operate ride-on rollers for ground compaction work"
  },
  {
    name: "Telescopic Handler",
    code: "A17",
    type: "With and without 360 slew",
    duration: "5 days training + 1 day test",
    price: "From £1,100",
    image: serviceImages.training,
    description: "Operate telescopic handlers for lifting and placing materials"
  },
  {
    name: "Traffic Marshall",
    code: "Traffic Management",
    type: "Site Safety",
    duration: "2 days",
    price: "From £1,100",
    image: serviceImages.excavator1,
    description: "Learn to safely manage vehicle and pedestrian movements on construction sites"
  },
  {
    name: "Slinger Signaller",
    code: "A40",
    type: "All Types / All Duties",
    duration: "4 days",
    price: "From £1,600",
    image: serviceImages.excavator2,
    description: "Comprehensive slinger signaller training covering all types and all duties"
  },
  {
    name: "Hoist Operator",
    code: "A26",
    type: "Passenger & Materials Hoist",
    duration: "2 days",
    price: "From £1,100",
    image: serviceImages.excavator3,
    description: "Operate passenger and materials hoists safely on construction sites"
  },
  {
    name: "Appointed Person",
    code: "A61",
    type: "Lifting Operations",
    duration: "5 days",
    price: "From £2,000",
    image: serviceImages.training,
    description: "Become qualified to plan and supervise all lifting operations on site"
  },
  {
    name: "Crane Supervisor",
    code: "A62",
    type: "Crane Operations",
    duration: "3 days",
    price: "From £2,200",
    image: serviceImages.excavator1,
    description: "Supervise crane operations and ensure safe lifting practices on site"
  }
];

export const siteManagementCourses = [
  {
    name: "SSSTS Course",
    fullName: "Site Supervisors Safety Training Scheme",
    duration: "2 days",
    price: "£300",
    level: "Supervisory",
    features: [
      "Health & safety responsibilities",
      "Risk assessment training",
      "Legal compliance",
      "Site safety management",
      "CITB approved",
      "Certificate valid 5 years"
    ],
    whoFor: ["Site Supervisors", "Team Leaders", "Chargehands", "First-time supervisors"]
  },
  {
    name: "SMSTS Course",
    fullName: "Site Managers Safety Training Scheme",
    duration: "5 days",
    price: "£550",
    level: "Management",
    features: [
      "Advanced safety management",
      "Legal responsibilities",
      "Site planning & control",
      "Environmental management",
      "CITB approved",
      "Certificate valid 5 years"
    ],
    whoFor: ["Site Managers", "Project Managers", "Construction Managers", "Senior supervisors"],
    popular: true
  }
];

export const whyChooseUs = [
  {
    icon: "Zap",
    title: "Fast Processing",
    description: "Quick turnaround times for all applications and bookings"
  },
  {
    icon: "DollarSign",
    title: "Affordable Prices",
    description: "Competitive rates with flexible payment options available"
  },
  {
    icon: "MapPin",
    title: "Nationwide Service",
    description: "Supporting construction workers across the UK"
  },
  {
    icon: "HeadphonesIcon",
    title: "Expert Support",
    description: "Dedicated team available to help with any questions"
  },
  {
    icon: "Award",
    title: "High Pass Rate",
    description: "Comprehensive training ensuring excellent success rates"
  },
  {
    icon: "Shield",
    title: "Trusted Provider",
    description: "Established reputation with thousands of satisfied customers"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Call or Apply Online",
    description: "Contact us by phone, WhatsApp, or fill out our online enquiry form"
  },
  {
    step: 2,
    title: "Complete Test / Course",
    description: "Book your test or enroll in the training course that suits your needs"
  },
  {
    step: 3,
    title: "Receive Your Card",
    description: "Get your CSCS or CPCS card and start working on construction sites"
  }
];

export const testimonials = [
  {
    name: "James Mitchell",
    role: "Construction Labourer",
    location: "London",
    rating: 5,
    text: "Brilliant service! Got my green CSCS card within a week. The team guided me through everything and made it so easy.",
    date: "2 weeks ago"
  },
  {
    name: "Sarah Thompson",
    role: "Site Supervisor",
    location: "Manchester",
    rating: 5,
    text: "Completed my SMSTS course here. Professional training, great instructors, and now I'm managing my own site. Highly recommend!",
    date: "1 month ago"
  },
  {
    name: "David Chen",
    role: "Plant Operator",
    location: "Birmingham",
    rating: 5,
    text: "Passed my 360 excavator CPCS test first time thanks to their excellent training. Worth every penny.",
    date: "3 weeks ago"
  },
  {
    name: "Mohammed Khan",
    role: "Electrician",
    location: "Leeds",
    rating: 5,
    text: "Fast, reliable, and affordable. Got my blue skilled worker card sorted quickly. The support team was amazing.",
    date: "1 week ago"
  }
];

export const faqs = [
  {
    category: "CSCS Cards",
    questions: [
      {
        q: "What is a CSCS card and why do I need one?",
        a: "A CSCS (Construction Skills Certification Scheme) card proves you have the required training and qualifications for your job on a construction site. Most UK construction sites require all workers to hold a valid CSCS card before being allowed on site."
      },
      {
        q: "How long does it take to get a CSCS card?",
        a: "The timeframe depends on the card type. A Green Labourer card can be obtained in as little as 1-2 weeks after completing the 1-day course. Skilled worker cards require completing an NVQ, which typically takes 6-16 weeks depending on the level."
      },
      {
        q: "How much does a CSCS card cost?",
        a: "Prices vary by card type. Green Labourer cards start from £150, Blue Skilled Worker cards from £1,200, Gold cards from £1,800, and Black management cards from £2,500. Contact us for exact quotes."
      },
      {
        q: "How long is a CSCS card valid?",
        a: "Most CSCS cards are valid for 5 years. You'll need to renew your card before it expires to continue working on construction sites."
      }
    ]
  },
  {
    category: "CPCS Training",
    questions: [
      {
        q: "What's the difference between Red and Blue CPCS cards?",
        a: "A Red CPCS card is a 'Trained Operator' card valid for 2 years, issued after passing your initial test. A Blue CPCS card is a 'Competent Operator' card valid for 5 years, obtained after completing your NVQ within the Red card period."
      },
      {
        q: "Can I operate machinery with just a Red CPCS card?",
        a: "Yes, a Red CPCS card allows you to operate machinery as a trained operator for up to 2 years. However, you must complete your NVQ and upgrade to a Blue card within this time to continue operating."
      },
      {
        q: "Which CPCS categories do you offer?",
        a: "We offer training for all major CPCS categories including 360 Excavators (A59), Forward Tipping Dumpers (A09), Ride on Rollers (A31), Telescopic Handlers (A17), and many more. Contact us for the full list."
      }
    ]
  },
  {
    category: "Booking & Payment",
    questions: [
      {
        q: "How do I book a course or test?",
        a: "You can book by calling us on +44 7848 482492, messaging us on WhatsApp at +44 7848 482492, or filling out our online enquiry form. We'll guide you through the entire process."
      },
      {
        q: "Do you offer payment plans?",
        a: "Yes, we offer flexible payment options for many of our courses. Contact us to discuss payment plans that suit your budget."
      },
      {
        q: "What happens if I fail my test?",
        a: "Don't worry! We provide comprehensive training to maximize your chances of passing. If you do need to retake a test, we'll support you with additional guidance and arrange a retest."
      }
    ]
  }
];

export const aboutContent = {
  mission: "Construction Cards Helpline Limited is dedicated to helping construction workers across the UK obtain the qualifications and cards they need to work safely and legally on construction sites.",
  story: "With years of experience in the construction training industry, we understand the challenges workers face in navigating the complex world of CSCS cards, NVQ qualifications, and CPCS certifications. Our mission is to make this process as simple, fast, and affordable as possible.",
  values: [
    {
      title: "Excellence",
      description: "We maintain the highest standards in training and customer service"
    },
    {
      title: "Support",
      description: "Our team is here to guide you every step of the way"
    },
    {
      title: "Integrity",
      description: "Honest advice and transparent pricing, always"
    },
    {
      title: "Results",
      description: "Your success is our success - we're committed to helping you pass"
    }
  ],
  stats: [
    { number: "10,000+", label: "Workers Trained" },
    { number: "95%", label: "Pass Rate" },
    { number: "15+", label: "Years Experience" },
    { number: "24/7", label: "Support Available" }
  ]
};

export const bookingFormFields = {
  services: [
    "CSCS Green Card (Labourer)",
    "CSCS Blue Card (Skilled Worker)",
    "CSCS Gold Card",
    "CSCS Black Card",
    "CPCS 360 Excavator",
    "CPCS Forward Tipping Dumper",
    "CPCS Ride on Roller",
    "CPCS Telescopic Handler",
    "SSSTS Course",
    "SMSTS Course",
    "NVQ Level 2",
    "NVQ Level 3",
    "General Enquiry"
  ]
};
